import { motion } from "framer-motion";
import { TrainFront, Shirt, Map, UtensilsCrossed, Rainbow } from "lucide-react";
import ChapterHeading from "@/components/home/ChapterHeading";

const ICONS = { map: Map, train: TrainFront, shirt: Shirt, food: UtensilsCrossed, rainbow: Rainbow };
const ACCENTS = ["text-neon-lime", "text-neon-cyan", "text-neon-purple", "text-neon-magenta", "text-neon-amber"];

const fallbackGuide = [
  { icon: "map", title: "Neighborhood Cheat-Sheet", rows: [["Center City", "Rooftops & cocktail temples"], ["Fishtown", "Indie venues & warehouse parties"], ["South Street", "Dive bars & neon chaos"], ["Old City", "Galleries & hidden speakeasies"]] },
  { icon: "train", title: "Moving After 2AM", rows: [["Broad St Line", "Runs 24h Fri–Sat nights"], ["Rideshare hubs", "City Hall & 2nd/Market"], ["PATCO", "Back to Jersey till late"], ["Night Owl buses", "Cover the subway gaps"]] },
  { icon: "shirt", title: "Dress Code Radar", rows: [["South Street", "Come as you are"], ["Rittenhouse rooftops", "Slick — no sneakers"], ["Callowhill warehouses", "Underground dark"], ["Fishtown", "Vintage everything"]] },
  { icon: "food", title: "Local Protocol", rows: [["Cheesesteak", "Order 'whiz wit' — whiz + onions"], ["Water ice", "It's 'wooder ice'. Say it right."], ["Tipping", "20% — bartenders remember"], ["Jawn", "Means anything. You'll hear it."]] },
];

export default function VisitorGuide({ city }) {
  if (city && !city.guide?.length) return null;
  const blocks = city?.guide?.length ? city.guide : fallbackGuide;
  const cityName = city?.name || "Philly";

  return (
    <section id="guide" className="mx-auto max-w-7xl px-5 py-24 sm:px-8" data-testid="visitor-guide-section">
      <ChapterHeading
        num="05 // OUT-OF-TOWN ESSENTIALS"
        title="The Visitor's Toolkit"
        accent="text-neon-cyan"
        sub={`Everything a first-timer needs to move through ${cityName} after dark like a local.`}
      />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {blocks.map((b, i) => {
          const Icon = ICONS[b.icon] || Map;
          const accent = ACCENTS[i % ACCENTS.length];
          return (
            <motion.div
              key={`${city?.id || "phl"}-${b.title}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="rounded-2xl border border-white/10 bg-[#131722] p-6 transition-all hover:-translate-y-1.5 hover:border-white/25"
              data-testid={`guide-card-${i}`}
            >
              <Icon className={`h-6 w-6 ${accent}`} />
              <h3 className="mt-4 font-display text-lg font-bold uppercase tracking-tight">{b.title}</h3>
              <ul className="mt-4 space-y-3">
                {b.rows.map(([k, v]) => (
                  <li key={k} className="border-b border-white/5 pb-3 last:border-0 last:pb-0">
                    <div className={`font-mono text-[11px] uppercase tracking-[0.2em] ${accent}`}>{k}</div>
                    <div className="mt-1 text-sm text-zinc-400">{v}</div>
                  </li>
                ))}
              </ul>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
